import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=ae51f944"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports